import type { ReactNode } from "react";

/** A small uppercase eyebrow label for a dashboard section, with an optional right-aligned action. */
export function SectionHeader({ title, action }: { title: string; action?: ReactNode }) {
  return (
    <div className="flex items-center justify-between gap-3 mb-3">
      <h3 className="text-xs font-medium uppercase tracking-wide text-muted">{title}</h3>
      {action}
    </div>
  );
}
